import { RouteObject } from 'react-router-dom'
import RootPage from './pages/RootPage'
import authRoutes from '../auth/routes'
// import adminRoutes from '../admin/routes';
// import operatorRoutes from '../operator/routes';
import notFoundRoutes from '../not-found/routes'
// import DashBoardPermissionGuard from './components/DashBoardPermissionGuard'
import adminRoutes from '../admin/routes'
import DashBoardPermissionGuard from './components/DashBoardPermissionGuard'
import operatorRoutes from '../operator/routes'

const rootRoutes: RouteObject[] = [
	{
		path: '/',
		element: <RootPage />,
		children: [
			authRoutes,
			{
				path: '',
				element: <DashBoardPermissionGuard />,
				children: [adminRoutes, operatorRoutes],
			},
		],
	},
	notFoundRoutes,
]

export default rootRoutes
